// import dependencies
import types from "../constants";

export const groupsAddGroup = payload => ({
    "type": types.GROUPS_SET_GROUP,
    payload
});
